import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import { GetTaskPoolQuery } from '../../../gql/graphql';
import { TaskPoolProgress } from '../../common/TaskPoolProgress';

interface AxisQuoteSubmissionProgressProps {
  taskPool: NonNullable<GetTaskPoolQuery['getTaskPool']> | null | undefined;
}

export const AxisQuoteSubmissionProgress = ({
  taskPool,
}: AxisQuoteSubmissionProgressProps) => {
  return (
    <Outer>
      <Heading variant='h6'>Submitting your answers...</Heading>
      <Description variant='body2'>
        Please wait while we process your submission.
      </Description>
      {taskPool ? (
        <TaskPoolProgress taskPool={taskPool} showTaskDetails={false} />
      ) : (
        <SpinnerContainer>
          <CircularProgress />
        </SpinnerContainer>
      )}
    </Outer>
  );
};

const Outer = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(3, 0),
}));

const Heading = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const Description = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(2),
}));

const SpinnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));
